<template>
    <div>
        <auth-container v-if="$route.name === 'SrReportProjectSummary'" :page="page">
            <h2 class="mb-4">A&amp;E Project Summary</h2>

            <div class="mx-auto">
                <b-row class="mb-3" align-v="end">
                    <b-col lg="6">
                        <b-form inline>
                            <b-input-group>
                                <b-form-input v-model="table.filter" placeholder="Search..." @input="filterChg"></b-form-input>

                                <b-input-group-append class="pointer mr-2">
                                    <b-input-group-text @click="clearFilter">
                                        <font-awesome-icon :icon="['fas', 'times']" />
                                    </b-input-group-text>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button variant="primary" type="button" @click="table.showAdvancedFilter = !table.showAdvancedFilter">Advanced Filter</b-button>
                        </b-form>
                    </b-col>
                    <b-col lg="6" class="text-right">
                        <div class="ml-auto">
                            Showing {{showingFirst}} - {{showingLast}}
                            of {{table.total}}
                        </div>
                    </b-col>
                </b-row>

                <b-collapse v-model="table.showAdvancedFilter" class="my-3">
                    <b-card bg-variant="light">
                        <b-row>
							<b-col lg="4">
								<div class="form-group row">
									<label for="advancedFilter.damName" class="col-lg-5 col-form-label">Dam Name</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.damName"
													 v-model="advancedFilter.damName"
													 :data="advancedFilter.options.damName"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.dam" class="col-lg-5 col-form-label">NID_ID</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.dam"
													 v-model="advancedFilter.dam"
													 :data="advancedFilter.options.dam"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.projectNumber" class="col-lg-5 col-form-label">TPN</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.projectNumber"
													 v-model="advancedFilter.projectNumber"
													 :data="advancedFilter.options.projectNumber"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.contractor" class="col-lg-5 col-form-label">Contractor</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.contractor"
													 v-model="advancedFilter.contractor"
													 :data="advancedFilter.options.contractor"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.workOrderNumber" class="col-lg-5 col-form-label">Work Order #</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.workOrderNumber"
													 v-model="advancedFilter.workOrderNumber"
													 :data="advancedFilter.options.workOrderNumber"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>
                            </b-col>
                            <b-col lg>
								<div class="form-group row">
									<label for="advancedFilter.projectType" class="col-lg-3 col-form-label">Project Type</label>
									<div class="col-lg-9">
										<b-typeahead id="advancedFilter.projectType" style="max-width:260px"
													 v-model="advancedFilter.projectType"
													 :data="setOptions.projectTypes"
													 :minMatchingChars="1" showAllResults showOnFocus>
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.fundingType" class="col-lg-3 col-form-label">Project Subtype</label>
									<div class="col-lg-9">
										<b-typeahead id="advancedFilter.projectSubtype" style="max-width:260px"
													 v-model="advancedFilter.projectSubtype"
													 :data="setOptions.projectSubtypes"
													 :minMatchingChars="1" showAllResults showOnFocus>
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.status" class="col-lg-3 col-form-label">Project Status</label>
									<div class="col-lg-9">
										<b-typeahead id="advancedFilter.status" style="max-width:260px"
													 v-model="advancedFilter.status"
													 :data="setOptions.statuses"
													 :minMatchingChars="1" showAllResults showOnFocus>
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.revisionDate.start" class="col-lg-3 col-form-label">Revision Date</label>
									<div class="col-lg-9">
										<div class="d-flex align-items-center justify-content-start">
											<div class="mr-2">
												<b-input-group>
													<b-form-datepicker id="advancedFilter.revisionDate.start" v-model="advancedFilter.revisionDate.start"
																	   label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.revisionDate.start = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
											<div>
												<b-input-group>
													<b-form-datepicker id="advancedFilter.revisionDate.end" v-model="advancedFilter.revisionDate.end"
																	   label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.revisionDate.end = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
										</div>
									</div>
								</div>
							</b-col>
                        </b-row>
                        <hr class="my-3" />
                        <div>
                            <b-button variant="primary" type="button" @click="get" class="mr-2">Apply</b-button>
                            <b-button variant="secondary" type="button" @click="clearAdvancedFilter" class="mr-2">Clear</b-button>
                            <b-button variant="secondary" type="button" @click="table.showAdvancedFilter = false">Close</b-button>
                        </div>
                    </b-card>
                </b-collapse>

				<b-table striped responsive table-class="table-fixed-height border-bottom table-grid" sticky-header="60vh"
						 small show-empty
						 :items="items" :busy="table.loading"
						 :fields="table.fields"
						 :no-local-sorting="true"
						 :sort-by.sync="table.sort"
						 :sort-desc.sync="table.reverse"
						 @sort-changed="sortChg">
					<template #table-busy>
						<div class="text-center my-4">
							<font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
						</div>
					</template>
					<template #cell(nid_id)="data">
						<router-link :to="`/dams/${data.item.damId}`">{{data.item.nid_id}}</router-link>
					</template>
					<template #cell(wo_tpn)="data">
						<router-link :to="`/sr/projects/${data.item.projectId}`">{{data.item.wo_tpn}}</router-link>
					</template>
					<template #cell(wo_num)="data">
						<router-link :to="`/sr/workorders/${data.item.workOrderId}`">{{data.item.wo_num}}</router-link>
					</template>
					<template #empty>
						<h4>No records found.</h4>
					</template>
					<template #emptyfiltered>
						<h4>No records found matching "{{table.filter}}".</h4>
					</template>
				</b-table>
            </div>

            <fixed-action-bar>
				<json-to-csv :api-url="`${apiUrl}export`" :filename="apiUrl" class="mr-2" />
                <b-pagination class="ml-auto mb-0" v-if="table.total > table.itemsPerPage" size="md" :total-rows="table.total" v-model="table.currentPage" :per-page="table.itemsPerPage" @change="pageChg" />
            </fixed-action-bar>            
        </auth-container>
        <router-view></router-view>
    </div>
</template>

<script>
    import _ from 'underscore';

    export default {
        name: 'SrReportProjectSummary',
        data() {
            return {
                apiUrl: 'srreports/projectsummary',
                page: {
                    errors: [],
                    loading: true,
                    showLogin: false,
                    saveErrors: [],
                    showModal: false,
                    showModal1: false,
                    showModal2: false
                },
                table: {
                    fields: [
                        { key: 'damName', label: 'Dam Name', sortable: true },
                        { key: 'nid_id', label: 'NID ID', sortable: true },
                        { key: 'wo_tpn', label: 'WO TPN', sortable: true },
                        { key: 'contractor', sortable: true },
                        { key: 'wo_num', label: 'WO #', sortable: true },
                        { key: 'projectType', label: 'Project Type', sortable: true },
                        { key: 'projectSubtype', label: 'Project Subtype', sortable: true },
                        { key: 'status', sortable: true },
                        { key: 'dateRevised', label: 'Date Revised', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } }
                    ],
                    sort: 'damName',
                    reverse: false,
                    itemsPerPage: 100,
                    filter: null,
                    currentPage: 1,
                    total: 0,
                    loading: false,
                    showAdvancedFilter: false
                },
                items: [],
                advancedFilter: {
                    workOrderNumber: null,
                    contractor: null,
                    projectType: null,
                    projectSubtype: null,
                    revisionDate: {
                        start: null,
                        end: null
                    },
                    dam: null,
                    damName: null,
                    projectNumber: null,
                    status: null,
                    options: {
                        workOrderNumber: [],
                        contractor: [],
                        dam: [],
                        damName: [],
                        projectNumber: [],
                    }
                },
                setOptions: {
                    statuses: [],
                    projectTypes: [],
                    projectSubtypes: []
                },
            }
        },
        computed: {
            showingFirst() {
                return this.table.total === 0 ? 0 : (this.table.currentPage - 1) * this.table.itemsPerPage + 1
            },
            showingLast() {
                var max = (this.table.currentPage - 1) * this.table.itemsPerPage + this.table.itemsPerPage
                return max > this.table.total ? this.table.total : max;
            },
            advancedFilterWorkOrderNumber() {
                return this.advancedFilter.workOrderNumber;
            },
            advancedFilterContractor() {
                return this.advancedFilter.contractor;
            },
            advancedFilterDam() {
                return this.advancedFilter.dam;
            },
            advancedFilterDamName() {
                return this.advancedFilter.damName;
            },
            advancedFilterProjectNumber() {
                return this.advancedFilter.projectNumber;
            },
        },
        async created() {
            await this.get();
        },
        watch: {
            '$route': 'get',
            advancedFilterWorkOrderNumber: _.debounce(function (query) { this.find('srworkorders', 'workOrderNumber', query) }, 500),
            advancedFilterContractor: _.debounce(function (query) { this.find('srworkorders', 'contractor', query) }, 500),
            advancedFilterDam: _.debounce(function (query) { this.findDams('nid_id', query) }, 500),
            advancedFilterDamName: _.debounce(function (query) { this.findDams('dam_name', query) }, 500),
            advancedFilterProjectNumber: _.debounce(function (query) { this.find('srprojects', 'projectNumber', query) }, 500),
        },
        methods: {
            getDb() {
                let sort = this.table.reverse ? this.table.sort + '_desc' : this.table.sort;
                let filter = this.table.filter !== null ? `&filter=${encodeURIComponent(this.table.filter)}` : '';

                let filterComplex = '';
                let filterValues = [];
                let stringFields = ['workOrderNumber', 'contractor', 'projectType', 'projectSubtype', 'dam', 'damName', 'projectNumber', 'status'];
                let twoPartFields = ['revisionDate'];

                for (let f of stringFields) {
                    if (!this.isNullOrEmpty(this.advancedFilter[f])) {
                        filterValues.push(`${f}:${this.advancedFilter[f]}`);
                    }
                }

                for (let f of twoPartFields) {
                    if (!this.isNullOrEmpty(this.advancedFilter[f].start) || !this.isNullOrEmpty(this.advancedFilter[f].end)) {
                        let s = this.advancedFilter[f].start;
                        let e = this.advancedFilter[f].end;
                        s = s === null ? 'any' : s;
                        e = e === null ? 'any' : e;
                        filterValues.push(`${f}:${s},${e}`);
                    }
                }

                if (filterValues.length > 0) filterComplex = '&filterComplex=' + filterValues.join('|');

                return this.$http.get(`${this.apiUrl}?sort=${sort}&page=${this.table.currentPage}&perPage=${this.table.itemsPerPage}${filter}${filterComplex}`, this.getTokenHeader());
            },
            async filterChg() {
                this.table.currentPage = 1;
                _.debounce(await this.get(), 500);
            },
            async pageChg(page) {
                this.table.currentPage = page;
                await this.get();
            },
            async sortChg(ctx) {
                this.table.sort = ctx.sortBy;
                this.table.reverse = ctx.sortDesc;
                this.table.specialSort = undefined;

                await this.get();
            },
            async get() {
                this.page.errors = [];
                this.table.loading = true;

                try {
                    const response1 = await this.$http.get(`${this.apiUrl}options`, this.getTokenHeader());
                    this.setOptions = response1.data;

                    const response = await this.getDb();
                    this.log(response.data);

                    if (response.data.items.length == 0 && this.table.currentPage > 1) {
                        this.table.currentPage--;
                        await this.get();
                    }

                    this.items = response.data.items;
                    this.table.total = response.data.total;
                } catch (error) {
                    if (this.isApiUnauthorized(error)) this.page.showLogin = true;
                    else this.page.errors = this.logError(error);
                }

                this.table.loading = false;
                this.page.loading = false;
            },
            async find(apiUrl, field, query) {
                try {
                    const response = await this.$http.get(`/${apiUrl}/find/${field}/${query}`, this.getTokenHeader());
                    this.advancedFilter.options[field] = response.data != '' ? response.data : [];
                } catch (error) {
                    this.page.errors = this.logError(error);
                }
            },
            async findDams(field, query) {
                try {
                    const response = await this.$http.get(`/dams/find/${field}/${query}`, this.getTokenHeader());
                    if (field == 'nid_id')
                        this.advancedFilter.options.dam = response.data != '' ? response.data : [];
                    else
                        this.advancedFilter.options.damName = response.data != '' ? response.data : [];
                } catch (error) {
                    this.page.errors = this.logError(error);
                }
            },
            async clearFilter() {
                this.table.filter = null;
                await this.get();
            },
            async clearAdvancedFilter() {
                this.advancedFilter = {
                    workOrderNumber: null,
                    contractor: null,
                    projectType: null,
                    projectSubtype: null,
                    revisionDate: {
                        start: null,
                        end: null
                    },
                    dam: null,
                    damName: null,
                    projectNumber: null,
                    status: null,
                    options: {
                        workOrderNumber: [],
                        contractor: [],
                        dam: [],
                        damName: [],
                        projectNumber: [],
                    }
                };

                await this.get();
            }
        }
    }
</script>